<h4 [innerHTML]="alertMsg"></h4>
<div class="center" style="display: flex;
justify-content: space-between;">
  <button *ngIf="alertType == 'info'" mat-raised-button class="bg-success" (click)="onYes()">Confirm</button>&nbsp;&nbsp;
  <button *ngIf="alertType == 'info'" mat-raised-button class="bg-danger" (click)="onCancel()">Cancel</button>
  <button *ngIf="alertType == 'warning'" mat-raised-button class="bg-danger" (click)="onCancel()">OK</button>
</div>